/**
 * Route helper - now using the unified navigation configuration
 *
 * @deprecated Please import helpers directly from '@/routers/utils'
 * This file is kept for backward compatibility
 */

import { findNavigationItem } from "@/routers/utils";

export const isRouteRegistered = (path: string): boolean => {
  const item = findNavigationItem(path);
  return item !== null;
};

export const validateRoute = (path: string): { isValid: boolean; message: string } => {
  const isValid = isRouteRegistered(path);
  return {
    isValid,
    message: isValid ? "Route is valid" : "Route not found in navigation config",
  };
};
